$(function() {
	// Set variables
	const body 				= $('body');
	const header 			= $('.site-header');
	const footer 			= $('.site-footer');
	const modal_overlay 	= $('.modal-overlay');
	const tablet_breakpoint = 1024;
	const mobile_breakpoint = 622;

	const header_height = header.outerHeight(); // plus triangle offcut + 74

	!function(t){var i=t(window);t.fn.visible=function(t,e,o){if(!(this.length<1)){var r=this.length>1?this.eq(0):this,n=r.get(0),f=i.width(),h=i.height(),o=o?o:"both",l=e===!0?n.offsetWidth*n.offsetHeight:!0;if("function"==typeof n.getBoundingClientRect){var g=n.getBoundingClientRect(),u=g.top>=0&&g.top<h,s=g.bottom>0&&g.bottom<=h,c=g.left>=0&&g.left<f,a=g.right>0&&g.right<=f,v=t?u||s:u&&s,b=t?c||a:c&&a;if("both"===o)return l&&v&&b;if("vertical"===o)return l&&v;if("horizontal"===o)return l&&b}else{var d=i.scrollTop(),p=d+h,w=i.scrollLeft(),m=w+f,y=r.offset(),z=y.top,B=z+r.height(),C=y.left,R=C+r.width(),j=t===!0?B:z,q=t===!0?z:B,H=t===!0?R:C,L=t===!0?C:R;if("both"===o)return!!l&&p>=q&&j>=d&&m>=L&&H>=w;if("vertical"===o)return!!l&&p>=q&&j>=d;if("horizontal"===o)return!!l&&m>=L&&H>=w}}}}(jQuery);

	// Set headspace height

	if ( !body.hasClass('headspace-null') ) {

		$('.headspace').height(header_height);

	}

	function getParameterByName( name ) {
      name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
      var regexS = "[\\?&]"+name+"=([^&#]*)";
      var regex = new RegExp( regexS );
      var results = regex.exec( window.location.href );
      if( results == null )
        return "";
      else
        return decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    $.fn.extend({
	    toggleText: function(a, b){
	        return this.text(this.text() == b ? a : b);
	    }
	});

    // Scroll up header

    function checkScrollPosition() {
    	if ($(window).scrollTop() >= 40) {
	        body.addClass('scrolled');
	    } else {
	    	body.removeClass('scrolled');
	    }
    };

    $(window).scroll(function () {
    	
    	checkScrollPosition();

    	if ($(window).scrollTop() >= 200) {

	    	$('.pricing-navigation').addClass('scrolled');

	    } else {

	    	$('.pricing-navigation').removeClass('scrolled');

	    }

    });

    checkScrollPosition();

    // Initialise home hero carousel

	$('.j-hero-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: true,
		fade: true,
		responsive: [
			{
				breakpoint: tablet_breakpoint,
				settings: {
					dots: false
				}
			}
		]
	});

	// Show account children in global sidebar

	// $(document).on('click', '.j-toggle-account', function(e){

	// 	e.preventDefault();
	// 	$(this).parent().find('.icon-children').slideDown();

	// });

	// // Close sidebar if clocked outside

	var sidebar = $('.global-sidebar');

	function close_global_sidebar(){

		sidebar.removeClass('expand');
    	modal_overlay.fadeOut();
    	$('.j-toggle-sidebar').find('span').text('Menu');
    	$('.sidebar-drawer').removeClass('expanded');
    	$('.j-load-sd').removeClass('active');

	}

	$(document).mouseup(function(e) {
	    
	    if (!sidebar.is(e.target) && sidebar.has(e.target).length === 0){
	        
	    	close_global_sidebar();

	    }
	});

	$(document).on('click', '.j-toggle-sidebar', function(){

		$('.global-sidebar').toggleClass('expand');
		$(this).find('span').toggleText('Menu', 'Close Menu');
		modal_overlay.fadeToggle();

		if ( !$('.global-sidebar').hasClass('expand') ){

			// Close all sidedrawers
			console.log('Close all sidedrawers');
			$('.sidebar-drawer').removeClass('expanded');
			$('.j-load-sd').removeClass('active');

		}

	});

	// Open sidebar drawers

	$(document).on('click', '.j-load-sd', function(e){

		e.preventDefault();
		var drawer = $(this).data('sd');
		modal_overlay.fadeIn();
		$('.j-load-sd').removeClass('active');
		$(this).addClass('active');

		$('.sidebar-drawer').removeClass('expanded');
		$('.sidebar-drawer.sd-' + drawer + '').addClass('expanded');

		$('.global-sidebar').addClass('expand');
		$('.j-toggle-sidebar span').text('Close Menu');


	});

	// Close sidebar drawers

	$(document).on('click', '.j-close-sd', function(e){
		
		e.preventDefault();
		close_global_sidebar();

	});

	// Initialize single spotlight block image carousel

	$('.j-ssb-img-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: true,
		autoplay: true,
		responsive: [
			{
				breakpoint: tablet_breakpoint,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: mobile_breakpoint,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	// Initialise product carousel

	$('.j-product-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: true,
		dots: false,
		autoplay: true,
		variableWidth: true,
		responsive: [
			{
				breakpoint: tablet_breakpoint,
				settings: {
					dots: true,
					arrows: false
				}
			}
		]
	});

	// Device menu toggle

	$(document).on('click', '.j-mobile-menu-toggle', function(e){

		e.preventDefault();
		body.toggleClass('menu-exapnded');

	});

	// Toggle child ul >li >ul in menu

	$(document).on('click', '.j-menu-child-trigger', function(e){

		e.preventDefault();
		$(this).toggleClass('active').parent().parent().find('ul').slideToggle();

	});

	// Footer menu column toggle < tablet

	if ($(window).width() < tablet_breakpoint) {

		$(document).on('click', '.j-footer-menu-toggle', function(){

			$(this).toggleClass('expanded').parent().find('ul').slideToggle();

		});

	}

	// Story hero toggle state

	$(document).on('click', '.j-show-hero-state', function(e){

		e.preventDefault();
		$(this).parent().toggleClass('expanded').siblings().removeClass('expanded').parent().addClass('active');


	});

	// Close hero toggle state

	$(document).on('click', '.j-close-story-block', function(e){

		e.preventDefault();
		$('.story-hero').removeClass('active');
		$('.story-hero .block').removeClass('expanded');

	});

	// Initiliase ride types carousel < tablet - about page

	if ($(window).width() < tablet_breakpoint) {

		$('.j-ride-type-blocks').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false,
			dots: false,
			autoplay: false,
			variableWidth: true
		});

	}

	// Load more articles - promos / events

	$(document).on('click', '.j-load-more-articles', function(e){

		e.preventDefault();
		$(this).fadeOut();
		$('.blog-template .single-spotlight-block').slideDown();

	});

	// Toggle ILP filters

	$(document).on('click', '.j-toggle-filter-visibility', function(e){

		e.preventDefault();
		$(this).toggleClass('active').parent().find('.options').slideToggle();

	});

	// Show instructors based on location filter

	$(document).on('click', '.j-ilp-location-trigger', function(e){

		e.preventDefault();
		var selection = $(this).data('location');
		var selection_title = $(this).text();
		$('.j-toggle-filter-visibility').text(selection_title);

		$(this).addClass('active').siblings().removeClass('active');

		if ( selection == 'all' ){

			$('.j-instructor-block').removeClass('inactive');

		} else {

			$('.j-instructor-block').each(function(index, el) {
				let locations = $(this).data('locations');

				if( locations !== undefined && locations.indexOf(selection) != -1){
					$(this).removeClass('inactive');
				} else {
					$(this).addClass('inactive');
				}
			});

		}

		$('.j-toggle-filter-visibility').removeClass('active').parent().find('.options').slideUp();

		// Clear saved filter

		$('.j-ilp-show-favs').removeClass('active');
		$('.j-cancel-saved').fadeOut();

	});

	// Close ILP filter options on mouseup

	$(document).mouseup(function(e) {
	    var filter_options = $('.instructor-listing-template .instructor-listing .header .filters');

	    if (!filter_options.is(e.target) && filter_options.has(e.target).length === 0){
	        
	    	$('.j-toggle-filter-visibility').removeClass('active').parent().find('.options').slideUp();


	    }
	});

	// Show ILP favouristes

	$(document).on('click', '.j-ilp-show-favs', function(e){

		e.preventDefault();

		// Reset location filter

		$('.j-ilp-location-trigger[data-location="all"]').trigger('click');
		$('.j-toggle-filter-visibility').text('Filter by location');
		
		$(this).toggleClass('active');
		$('.j-cancel-saved').fadeIn();
		$('.j-instructor-block').addClass('inactive');
		$('.j-instructor-block.isFavourite').removeClass('inactive');

	});

	// Cancel ILP favourite selection

	$(document).on('click', '.j-cancel-saved', function(e){

		e.preventDefault();
		$(this).fadeOut();
		$('.j-ilp-show-favs').removeClass('active');
		$('.j-instructor-block').removeClass('inactive');

	});

	// Initialise purchase card carousel if 4 or >

	if ($(window).width() > tablet_breakpoint) {

		$('.j-purchase-block-carousel').slick({
			infinite: false,
			slidesToShow: 2,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			dots: false,
			autoplay: false,
			variableWidth: true
		});

	}

	// Set matchHeight on slide blocks

	//$('.codex-purchase-section .blocks.slick-slider .slick-slide').matchHeight();

	//  Toggle video filter options

	$(document).on('click', '.j-filter-title', function(e){

		e.preventDefault();
		$(this).toggleClass('active').parent().find('.dynamic-filter-checkbox, .dynamic-filter-radio').slideToggle();

	});

	//  Toggle video filter search form

	$(document).on('click', '.j-video-search-toggle', function(e){

		e.preventDefault();
		$(this).toggleText('Search', 'Close').parent().find('.search-form').slideToggle();

	});

	// Close video filters on mouseup

	$(document).mouseup(function(e) {
	    var video_filter_item = $('.filter-item');

	    if (!video_filter_item.is(e.target) && video_filter_item.has(e.target).length === 0){
	        
	    	video_filter_item.find('.j-filter-title').removeClass('active').parent().find('.dynamic-filter-checkbox, .dynamic-filter-radio').slideUp();


	    }
	});

	// Toggle filter options on video listing page < tablet

	$(document).on('click', '.j-device-filter-trigger', function(e){

		e.preventDefault();
		$(this).toggleClass('active').parent().find('.video-filter-wrapper').slideToggle();

	});

	// Faq accordion toggle

	$(document).on('click', '.j-acc-q-toggle', function(){

		$(this).toggleClass('active').next('article').slideToggle();

	});

	// Show tablet and mobile filter options on collection page

	$(document).on('click', '.j-collection-filter-toggle', function(e){

		e.preventDefault();
		$(this).toggleClass('active').parent().find('.cat-title').slideToggle();
		$('.collection-template .sorting').slideToggle();

	});

	$(document).on('click', '.j-toggle-c-cats', function(e){

		e.preventDefault();
		$(this).toggleClass('active').parent().find('.item').slideToggle();

	});

	// Show product features - roduct template

	$(document).on('click', '.j-p-features', function(e){

		e.preventDefault();
		$(this).toggleClass('active').parent().find('.features').slideToggle();

	});

	// Close shopify cart

	var shopifyCart = $('.cart-wrapper');

	$(document).on('click', '.j-close-shopify-cart', function(e){

		e.preventDefault();
		shopifyCart.fadeOut();

	});

	// Show shopify cart

	$(document).on('click', '.j-merch-cart', function(e){

		e.preventDefault();
		close_global_sidebar();
		shopifyCart.fadeIn(); 

		$('.cart-upsells .products .item .product-card .product-title').matchHeight({ property: 'min-height' });

	});

	// Initilaise cart upsell carousel on tablet and mobile

	if ($(window).width() < tablet_breakpoint) {

		$('.j-cart-upsell-carousel').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false,
			dots: false,
			autoplay: false,
			variableWidth: true
		});

	}

	// Show filter options on timetable page

	$(document).on('click', '.j-timetable-filter-toggle', function(e){

		e.preventDefault();
		$(this).toggleClass('active').parent().find('.filter-components, .tod-filters').slideToggle();

	});

	// Close timtable location modal

	$(document).on('click', '.j-close-tt-modal', function(e){

		e.preventDefault();
		$('.tt-location-modal').fadeOut();

	});

	// Scroll to location / pages/locations

	$(document).on('click', '.j-scroll-to-location', function(e){

		e.preventDefault();
		var index = $(this).data('index');

		$("html, body").animate({
			scrollTop: $('#location-block-' + index + '').offset().top - header_height
		}, 1000);

		$('.j-show-locations').trigger('click');

	});

	// Show locations

	$(document).on('click', '.j-show-locations', function(e){

		e.preventDefault();
		$(this).toggleClass('active').parent().find('.items').slideToggle();

	});

	// Show OOS form on product page

	$(document).on('click', '.j-show-oos-form', function(e){

		e.preventDefault();
		$(this).parent().slideUp().parent().find('.oos-form').slideDown();

	});

	// Scrolling on timetable calendar widget

	$(document).on('click', '.j-calendar-widget', function(e){

		e.preventDefault();

		if ( !$('.calendar-carousel .c-block').hasClass('active') ){

			console.log('is not active');
			$('.calendar-carousel .c-block').first().addClass('active');

		}

		if ( $(this).hasClass('prev') ){

			if ( $('.calendar-carousel .c-block:nth-child(2)').hasClass('active') ){

				$('.j-calendar-widget.prev').hide();

			} else {

				$('.j-calendar-widget.prev').show();
				$('.calendar-carousel')[0].scrollLeft -= 60;
				$('.calendar-carousel .c-block.active').prev().trigger('click');

			}

		} else {

			$('.calendar-carousel')[0].scrollLeft += 60;
			$('.calendar-carousel .c-block.active').next().trigger('click');

		}

		

	});

	$(document).on('click', '.j-c-block', function(){

		$(this).addClass('active').siblings().removeClass('active');

	});

	// Force page reload

	$(document).on('click', '.j-reload-page', function(e){

		e.preventDefault();
		location.reload();

	});

	// Scroll to pricing section

	$(document).on('click', '.j-scroll-pricing', function(e){

		e.preventDefault();

		var section = $(this).data('scrollto');

		$("html, body").animate({
			scrollTop: $('#shopify-section-' + section + '').offset().top - header_height
		}, 1000);

	});

	// Scroll to first timers section

	$(document).on('click', '.j-scroll-to-register', function(e){

		e.preventDefault();

		$("html, body").animate({
			scrollTop: $('#codex-ft-components').offset().top - header_height
		}, 1000);

	});

	// Scroll to section

	$(document).on('click', '.j-scrollto-section', function(e){

		e.preventDefault();

		var section = $(this).data('section');

		$(this).addClass('active').siblings().removeClass('active');

		$("html, body").animate({
			scrollTop: $('#' + section + '').offset().top - header_height
		}, 1000);

		if ($(window).width() < tablet_breakpoint) {

			$('.pricing-navigation nav a').slideToggle();

		}

	});

	$(document).on('click', '.j-show-pricing-nav', function(e){

		e.preventDefault();
		$(this).toggleClass('expanded').parent().find('nav a').slideToggle();

	});










	// Simple add to cart function
	function addToCart(_this){
        var variantID = _this.data('vid');
        var variantQty = _this.data('qty');
        var tags = _this.data('tags');
        var properties  = { _tags: tags };

        var buttonText = _this.html();

        console.log(variantID);
        console.log(variantQty);
        console.log(properties);

        CartJS.addItem(variantID, variantQty, properties, {
            "success": function(data, textStatus, jqXHR) {
                console.log('added to basket');
                _this.html('Added!');
				setTimeout(function(){
					_this.html(buttonText);
				}, 3000);
            },
            "error": function(jqXHR, textStatus, errorThrown) {
                console.log('cart js Error');
                _this.html('An error occurred');
				setTimeout(function(){
					_this.html(buttonText);
				}, 3000);
            }
        });
    }

    $(document).on('click', '.j-add-product', function(e){
    	e.preventDefault();
    	var _this = $(this);
    	addToCart(_this);
    });

    $(document).on('cart.requestComplete', function(event,cart) {
        cartRequestComplete();
    });

	function cartRequestComplete() {
		console.log('cartRequestComplete');
		jQuery.getJSON('/cart.js', function(cart) {
			var cart_text = $('#codex-cart-icon a');
			if ( cart_text.length == 0 ){
				$('#codex-cart-icon a').removeClass('filled' );
			} else {
				$('#codex-cart-icon a').addClass('filled');
			}
		});
    }

    // Password checker on customer register form

    $('#create_customer').on('submit', function(e){

		var password1 = $('#CreatePassword').val();
		var password2 = $('#ConfirmPassword').val();

		if (password1 === password2){
			console.log('true')
		} else {
			e.preventDefault();
			$('.error-container').html('<p>Passwords do not match. Please try again.</p>')
		}
	});

	// IE11 detection
	var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
	var IE11Warning = '<div class="browser-warning"><p>We only offer partial support for this browser. To get the best experience we recommend downloading <a href="https://www.google.com/intl/en/chrome/" target="_blank"><u>Google Chrome</u></a>.</p><span class="close-icon j-close-browser-warning"></span></div>';
	if ( isIE11 == true ){
		body.append(IE11Warning);
		$(document).on('click', '.j-close-browser-warning', function(e){
			$('.browser-warning').fadeOut();
		});
	}

	$('.slick-slider').show(); // Show all carousels once page loaded - must be after all slick calls

	var rellax = new Rellax('.rellax', {
		horizontal: true,
	});

	// Codex cart - card toggle state

	$(document).on('click', '.j-card-toggle', function(){

		$(this).toggleClass('active');

	});


	// CODEX SPECIFIC FUNCTIONS

	$(document).on('click', '.__codex-loginsummary-login', function(e){
        e.preventDefault();
        document.dispatchEvent(new Event('codex-login-toggle'));
    });

    $(document).on('click', '.j-cart-trigger', function(e){

        e.preventDefault();
        document.dispatchEvent(new Event('codex-cart-toggle'));

    });

    $(document).on('click', '.j-show-password-reset-form', function(){

    	$('.codex-login-form').slideUp();
    	$('.j-show-password-reset-form').slideUp();
    	$('.codex-password-rest-form').slideDown();
    	$('.j-show-password-login-form').slideDown();

    });

    $(document).on('click', '.j-hide-password-reset-form', function(){

    	$('.codex-login-form').slideDown();
    	$('.j-show-password-reset-form').slideDown();
    	$('.codex-password-rest-form').slideUp();
    	$('.j-show-password-login-form').slideUp();
    	$('.codex-password-update-form').slideUp();

    });

    $(document).on('click', '.j-show-password-login-form', function(){

    	$('.codex-password-rest-form').slideUp();
    	$('.j-show-password-login-form').slideUp();
    	$('.codex-login-form').slideDown();
    	$('.j-show-password-reset-form').slideDown();

    });

    $(document).on('click', '.j-show-register-form', function(e){

    	e.preventDefault();
    	$('.j-load-sd[data-sd="register"]').trigger('click');

    });

	$('.j-load-sd[data-sd="register"]').trigger('click');

    $(document).on('click', '.j-show-login-form', function(e){

    	e.preventDefault();
    	$('.j-load-sd[data-sd="login"]').trigger('click');

    });

    $(document).on('click', '.j-show-cart-drawer', function(e){

    	e.preventDefault();
    	$('.j-load-sd[data-sd="cart"]').trigger('click');

    	if ( $(this).hasClass('ecom') ){

    		shopifyCart.fadeOut();

    	}

    });

    $(document).on('click', '.j-show-purchase-drawer', function(e){

    	e.preventDefault();
    	$('.j-load-sd[data-sd="purchase"]').trigger('click');

    });

    // URL checks to trigger sidebar elements
	setTimeout(() => {
		if ( document.location.href.indexOf('?register=true') > -1 ) {
			$('.j-load-sd[data-sd="register"]').trigger('click');
		}

		if ( document.location.href.indexOf('?login=true') > -1 ) {
			$('.j-load-sd[data-sd="login"]').trigger('click');
		}

		if ( document.location.href.indexOf('?password-reset=true') > -1 ) {
			$('.j-load-sd[data-sd="login"]').trigger('click');
			$('.j-show-password-reset-form').trigger('click');
		}

		if ( document.location.href.indexOf('?password-update=true') > -1 ) {
			setTimeout(() => {
			$('.j-load-sd[data-sd="login"]').trigger('click');
			$('#codex-login .codex-login-form, #codex-login .codex-password-rest-form').hide();
			$('#codex-login .codex-password-update-form').show();
			}, 1000)
		}

		if ( document.location.href.indexOf('?cart=true') > -1 ) {
			$('.j-load-sd[data-sd="cart"]').trigger('click');
		}

		if ( document.location.href.indexOf('?purchase=true') > -1 ) {
			$('.j-load-sd[data-sd="purchase"]').trigger('click');
		}

		if ( document.location.href.indexOf('?ecom-cart=true') > -1 ) {
			$('.j-merch-cart').trigger('click');
		}

		if ( document.location.href.indexOf('&legacy') > -1 ) {
			console.log('is legacy customer');
			$('#legacy-customer-note').show();
			$('.j-hide-when-legacy-customer-note').hide();
		}
	}, 2000);
		
    // Codex account nav trigger

    $(document).on('click', '.j-open-membership-tab', function(){
    	$('.j-account-nav-link[data-accounttab="memberships"]').trigger('click');
    });

    $(document).on('click', '.j-click-account-menu-item', function(e){

    	e.preventDefault();
    	var tab = $(this).data('tab');
    	$('.j-account-nav-link[data-accounttab="' + tab + '"]').trigger('click');

    });

    $(document).on('click', '.j-account-nav-link', function(){

    	var currentTab = $(this).data('accounttab');
        window.history.pushState(currentTab, currentTab, '?tab=' + currentTab + '');
        $('.codex-account-template').removeClass('menu-expanded');

        // Scroll to top
        $("html, body").animate({
			scrollTop: $('.account-output').offset().top
		}, 500);

		if ($(window).width() < mobile_breakpoint) {

			setTimeout(function(){

				$('.codex-account-template').css('display', 'block');

			}, 500);

		}

    });

    var accountTab = getParameterByName("tab");
    if ( accountTab.length ){

	    console.log('accountTab', accountTab);
	    $('.j-account-nav-link[data-accounttab="' + accountTab + '"]').trigger('click');

	}

	$(document).on('click', '.j-account-menu-trigger', function(e){

		e.preventDefault();
		$('.codex-account-template').toggleClass('menu-expanded');

	});

	$(document).on('click', '.j-show-plan-perks', function(e){

		e.preventDefault();
		$(this).toggleText('Perks', 'Close').parent().parent().find('.benefits').slideToggle();

		setTimeout(function(){

			$('.account-overview-blocks .block .subscription-blocks .block').matchHeight({ property: 'min-height' });

		}, 500);

	});

	if ( $('.j-checkout').hasClass('disabled') ){

		console.log('disable checkout button');
		$('.j-checkout').text('Accept to continue');

	}

	$(document).on('change', '#has-plan-terms', function(){

		console.log('Changed');

		if ( $(this).is(":checked") ){

			console.log('is checked');
			$('.j-checkout').text('Checkout');
			$('.j-checkout').removeClass('disabled');

		} else {

			$('.j-checkout').text('Accept to continue');
			$('.j-checkout').addClass('disabled');

		}

	});

	function sanitizeMCreponse(resp){
		var msg = "";

		var index = -1;
		try {
			var parts = resp.msg.split(' - ', 2);
			if (parts[1] === undefined) {
				msg = resp.msg;
			} else {
				var i = parseInt(parts[0], 10);
				if (i.toString() === parts[0]) {
					index = parts[0];
					msg = parts[1];
				} else {
					index = -1;
					msg = resp.msg;
				}
			}
		}
		catch (e) {
			index = -1;
			msg = resp.msg;
		}
		return msg;
	}

	$('.mc-form-footer').ajaxChimp({	
	    url: 'https://bodhiandride.us3.list-manage.com/subscribe/post?u=1a225da3ddfc199c0531e638b&amp;id=cb006e1d19',
	    callback: function (resp) {
	        console.log(resp);
	        if (resp.result === "success") {

	        	$('.mc-form-footer .mc-message.error').hide().html('');
	        	$('.mc-form-footer .mc-message.success').show().html(resp.msg);
	            
	        } else {
	            console.log(resp.msg);

	        	$('.mc-form-footer .mc-message.success').hide().html('');

	        	var msg = sanitizeMCreponse(resp);

				if( msg.includes("is already subscribed") ) {
					$('.mc-form-footer .mc-message.error').show().html('You are already subscribed');
				} else  {
					$('.mc-form-footer .mc-message.error').show().html(resp.msg);
				}

	        }
	    }
	});

	$('.mc-form-modal').ajaxChimp({	
	    url: 'https://bodhiandride.us3.list-manage.com/subscribe/post?u=1a225da3ddfc199c0531e638b&amp;id=cb006e1d19',
	    callback: function (resp) {
	        console.log(resp);
	        if (resp.result === "success") {

	        	$('.mc-form-modal .mc-message.error').hide().html('');
	        	$('.mc-form-modal .mc-message.success').show().html(resp.msg);

	        	setTimeout(function(){

	        		$('.j-close-newsletter-modal').trigger('click');

	        	}, 3000);
	            
	        } else {
	            console.log(resp.msg);

	            $('.mc-form-footer .mc-message.success').hide().html('');

	        	var msg = sanitizeMCreponse(resp);

				if( msg.includes("is already subscribed") ) {
					$('.mc-form-footer .mc-message.error').show().html('You are already subscribed');
				} else  {
					$('.mc-form-footer .mc-message.error').show().html(resp.msg);
				}
	            
	        }
	    }
	});

	$('.mc-form-product').ajaxChimp({	
	    url: 'https://bodhiandride.us3.list-manage.com/subscribe/post?u=1a225da3ddfc199c0531e638b&amp;id=cb006e1d19',
	    callback: function (resp) {
	        console.log(resp);
	        if (resp.result === "success") {

	        	$('.mc-form-product .mc-message.error').hide().html('');
	        	$('.mc-form-product .mc-message.success').show();
	            
	        } else {
	            console.log(resp.msg);

	            $('.mc-form-footer .mc-message.success').hide().html('');

	        	var msg = sanitizeMCreponse(resp);

				if( msg.includes("is already subscribed") ) {
					$('.mc-form-footer .mc-message.error').show().html('You are already subscribed');
				} else  {
					$('.mc-form-footer .mc-message.error').show().html(resp.msg);
				}
	            
	        }
	    }
	});

	// Close verification modal

	$(document).on('click', '.j-close-verification-modal', function(e){

		e.preventDefault();
		$('.verify-sms-modal').fadeOut();

	});

	// Custom trigger event on FB messenger widget

	$(document).on('click', '.j-toggle-chat', function(e){

		e.preventDefault();

		// if ($(window).width() < tablet_breakpoint) {

		// 	$('#fb-customer-chat').show();

		// } else {
		// 	//console.log('Force messenger open');
		// 	FB.CustomerChat.showDialog();
		// }

		FB.CustomerChat.showDialog();

	});

	document.addEventListener('click', function(event) {
		if (event.target.matches('.j-cdx-cart')) {
			event.preventDefault();
			document.dispatchEvent(new Event('codex-modal-toggle.cart-modal'));
		}

		if (event.target.matches('.j-cdx-login')) {
			event.preventDefault();
			document.dispatchEvent(new Event('codex-modal-toggle.login-modal'));
		}

		if (event.target.matches('.j-cdx-register')) {
			event.preventDefault();
			document.dispatchEvent(new Event('codex-modal-toggle.register-modal'));
		}
	}, false);

	$('.j-referral').on( "mousemove", function( event ) {
		
		if ($(window).width() < 1024 || $('.j-referral').hasClass('right')) {
			$( ".tooltip" ).css({
				"left" : event.offsetX - 100,
				"top" : event.offsetY + 34
			});
		} else {
			$( ".tooltip" ).css({
				"left" : event.offsetX + 10,
				"top" : event.offsetY + 34
			});
		} 
		
	});

	$(document).on('click', '.referral-code-wrapper a', function(e){
		$(this).closest('.content').find('.btn').fadeOut('fast');
		$(this).closest('.content').find('.thank-you').fadeIn();
	});

	$(document).on('click', '.j-referral-info', function(e){
		e.preventDefault();

		$(this).closest('.referral-blocks').find('.more-info-container').fadeIn();
	});

	$(document).on('click', '.j-referral, .referral-code-outer', function(e){
		e.preventDefault();
		console.log('click');
		var $temp = $("<input>");
		var span = 'Click to copy';

		

		$("body").append($temp);
		$temp.val($('.referral-code').data('value')).select();
		document.execCommand("copy");
		$temp.remove();

		$('.tooltip').html('Code copied to clipboard');
		$(this).closest('.referral-code-wrapper').addClass('copied');

		setTimeout(function(){

			$('.tooltip').text(span);
			$('.referral-code-wrapper').removeClass('copied');

		},3000);

		$(this).closest('.content').find('.btn').fadeOut('fast');
		$(this).closest('.content').find('.thank-you').fadeIn();
		
	});

	// new buy page

	$('.j-buy-overview').slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		variableWidth: true,
		arrows: false,
		dots: false,
		autoplay: false,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: tablet_breakpoint,
				settings: {
					arrows: true
				}
			}
		]
	});
	
});